module.exports = __webpack_public_path__ + "static/media/9.1e875a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/9.jpg
// module id = 479
// module chunks = 0